import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { plainToClass } from 'class-transformer';
import { environment } from '../../../environments/environment';
import { CollectApiServiceBase } from './collect-api-base.service';
import { ProgressIndicatorService } from './progress-indicator.service';
import { TransitionFormInstances } from '../models/site-metadata/transition-form-instances.model';
import { UserWorkflowTransition } from '../models/site-metadata/user-workflow-transition.model';
import { MultiTemplateFormsGridBulkWorkflowData } from '../models/site-metadata/multi-template-forms-grid-bulk-wf-data.model';

@Injectable({
    providedIn: 'root'
})
export class UserWorkflowTransitionService extends CollectApiServiceBase<UserWorkflowTransition> {
    // Properties.
    // No properties at this time.

    // Constructor.
    public constructor(http: HttpClient, progressIndicatorService: ProgressIndicatorService) {
        super(http, progressIndicatorService, environment.apiUrl, 'userWorkflowTransition', UserWorkflowTransition)
    }

    // Implement formatResponse.
    public formatResponse(data: UserWorkflowTransition): UserWorkflowTransition {
        let obj = plainToClass(UserWorkflowTransition, data);
        return (obj);
    }

    // Service methods.
    public getUserAvailableWorkflowTransitions(formTemplateId: number): Promise<UserWorkflowTransition[]> {
        let url = `${this.url}/${this.endpoint}/GetUserAvailableWorkflowTransitions/${formTemplateId}`; 

        return this.http.get<UserWorkflowTransition[]>(url)
            .toPromise()
            .then(response => {
                let result: UserWorkflowTransition[] = [];
                if ((response != null) && (response.length > 0)) {
                    for (let index: number = 0; index < response.length; index++) {
                        let responseObject = response[index];
                        let transition: UserWorkflowTransition = this.formatResponse(responseObject);
                        result.push(transition);
                    }                    
                }
                return result;
            })
            .catch(this.handleError);
    }

    public multiTemplateFormsGridFormInstancesReferenceCommonWorkflow(formsGridFormFieldId: number, formInstanceIds: number[]): Promise<boolean> {
        const formInstanceIdsText = formInstanceIds.join(',');
        const data = new MultiTemplateFormsGridBulkWorkflowData(formsGridFormFieldId, formInstanceIdsText);
        let url = `${this.url}/${this.endpoint}/MultiTemplateFormsGridFormInstancesReferenceCommonWorkflow`;

        return this.http.put<boolean>(url, data)
            .toPromise()
            .then(response => {
                let result: boolean = false;
                if (response != null) {
                    result = response;
                }
                return result;
            })
            .catch(this.handleError);
    }

    public getMultiTemplateUserAvailableWorkflowTransitions(formsGridFormFieldId: number, formInstanceIds: number[]): Promise<UserWorkflowTransition[]> {
        const formInstanceIdsText = formInstanceIds.join(',');
        const data = new MultiTemplateFormsGridBulkWorkflowData(formsGridFormFieldId, formInstanceIdsText);
        let url = `${this.url}/${this.endpoint}/GetMultiTemplateUserAvailableWorkflowTransitions`;

        return this.http.put<UserWorkflowTransition[]>(url, data)
            .toPromise()
            .then(response => {
                let result: UserWorkflowTransition[] = [];
                if ((response != null) && (response.length > 0)) {
                    for (let index: number = 0; index < response.length; index++) {
                        let responseObject = response[index];
                        let transition: UserWorkflowTransition = this.formatResponse(responseObject);
                        result.push(transition);
                    }
                }
                return result;
            })
            .catch(this.handleError);
    }

    public transitionFormInstances(transitionInfo: TransitionFormInstances): Promise<any> {
        let url = `${this.url}/${this.endpoint}/TransitionFormInstances`;

        return this.http.post<TransitionFormInstances>(url, transitionInfo)
            .toPromise()
            .then(response => {
                return response;
            });
    }
}
